import { Component } from '@angular/core';

@Component({
	selector: 'vcm-redirect',
	template: require('./redirect.component.html')
})

export class RedirectComponent {
}